import React from "react";

export default function BlackBarScroller({
  text =
    "Travel Partner! || For accessing our new website! || Please reset your password using your registered email ID and log in to explore our new interface with the best price guarantee !!!",
  speed = 40, // seconds for one full loop
}) {
  return (
    <div className="w-full overflow-hidden bg-black text-white h-8 flex items-center px-6">
      <style>{`
        @keyframes scroll-rtl {
          0% { transform: translateX(100%); }
          100% { transform: translateX(-100%); }
        }
      `}</style>

      <div
        className="whitespace-nowrap"
        style={{
          display: "inline-block",
          animation: `scroll-rtl ${speed}s linear infinite`,
          paddingLeft: "1.5rem", // Add padding before scroll starts
          paddingRight: "1.5rem", // Add padding after scroll ends
        }}
      >
        {text}
        {/* <span className="mx-4">•</span>
        {text} */}
      </div>
    </div>
  );
}
